var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-py-2 gc-mb-2"},[_c('h2',{staticClass:"gc-text-primary gc-text gc-my-1 gc-text-xl gc-font-bold"},[_vm._t("default")],2),_c('gc-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }